import { render, staticRenderFns } from "./imgcarousel.vue?vue&type=template&id=21e772bd&"
import script from "./imgcarousel.vue?vue&type=script&lang=js&"
export * from "./imgcarousel.vue?vue&type=script&lang=js&"
import style0 from "./imgcarousel.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports